var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconZehtnerGlossmeterLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009CA6",
    d: "M212 0h816c117.1 0 212 94.9 212 212v816c0 117.1-94.9 212-212 212H212c-117.1 0-212-94.9-212-212V212C0 94.9 94.9 0 212 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M193.3 451h-.3v87.9h230.3L193 701.3V789h374.8v-88.4H334.5l233.3-161.8V451H193.3zM735.2 451h-50.7c-7.7 0-15.4 1.7-22.3 5.1-7.1 3.4-13.6 8.2-18.9 14.1-1 1.1-1.8 2.4-2.7 3.6-9.8 11.2-15 24.7-15.6 40.5-.1 1.1-.2 2.1-.2 3.2v208.1c0 9 1.7 17.8 5.2 26.1l1.2 2.4c.6 1.3 1.2 2.5 1.9 3.8 2.7 5.4 6.1 10.5 10.2 15 5.3 5.9 11.7 10.7 18.9 14.1 7.1 3.4 15.4 6.6 23.2 6.6H937v34.5c0 15-7.5 22.6-22.6 22.6H737.3V939H981c18.6 0 34.5-5.1 47.5-15.4s19.5-24.8 19.5-43.4V451H735.2zm201.4 150.3v78.6c0 15.5-6.9 23.9-20.7 23.9H757.8c-13.8 0-20.6-6.3-20.6-21.8V564c0-15.5 6.9-23.3 20.6-23.3h158c13.8 0 20.7 7.8 20.7 23.3l.1 37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconZehtnerGlossmeterLive);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconZehtnerGlossmeterLive.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };